import { Loader2, Save } from "lucide-react";

export const StickyBar = ({ children, onSave, saving, label, testid }) => (
  <div className="fixed inset-x-0 bottom-[calc(4rem+env(safe-area-inset-bottom))] z-30 border-t bg-card/95 backdrop-blur-lg" data-testid={`${testid}-bar`}>
    <div className="mx-auto flex max-w-3xl items-center gap-3 px-4 py-3">
      <div className="min-w-0 flex-1">{children}</div>
      <button className="btn btn-accent shrink-0" onClick={onSave} disabled={saving} data-testid={`${testid}-save-btn`}>
        {saving ? <Loader2 size={18} className="animate-spin" /> : <Save size={18} />} {label}
      </button>
    </div>
  </div>
);

export const Field = ({ label, children, className = "" }) => (
  <div className={`min-w-0 ${className}`}>
    <label className="label">{label}</label>
    {children}
  </div>
);

export const PageHead = ({ kicker, title, sub }) => (
  <div>
    <p className="mono-label text-brand">{kicker}</p>
    <h1 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
    {sub && <p className="text-sm text-muted-foreground">{sub}</p>}
  </div>
);
